import NoInfoAvailable from './NoInfoAvailable';

export default NoInfoAvailable;
